var _ = require('lodash');

var LightboxInsertions = function(page) {
  this.page              = page;
  this.mobileBreakpoint  = page.getBreakpointByName('mobile');
  this.desktopBreakpoint = page.getBreakpointByName('desktop');
  this.elms              = this._getLightboxElements();
};

LightboxInsertions.prototype.getLibraryInsertion = function() {
  // Check whether the ubpoverlay JS and CSS have already been inserted - i.e.
  // if there is a form module on the page. If not, add them as an insertion.
  // This ensures the files are inserted at most once.
  if (this.elms.all.length > 0 && ! this.page.hasForm()) {
    return {
      content: [
        this.page.publishedStylesheetTag('published/jquery.ubpoverlay.css'),
        this.page.publishedScriptTag('published/jquery.ubpoverlay.js')
      ].join('\n'),
      placement: 'head'
    };
  }
};

LightboxInsertions.prototype.getMainInsertion = function() {
  // Builds insertion containing main.js file, generic lightbox stylesheet and
  // per-element registerLightbox calls

  if (this.elms.all.length > 0) {
    var insertion = [
      this.page.publishedStylesheetTag('published/lightbox.css', 'lightbox-stylesheet'),
      this.page.publishedScriptTag('published/lightbox.js')
    ];

    if (this.elms.needInsertion.length > 0) {
      insertion = insertion.concat([
        '<script type="text/javascript">',
        this._getElementScripts(),
        '</script>'
      ]);
    }

    return {
      content   : '\n' + insertion.join('\n') + '\n',
      placement : 'head'
    };
  }
};

LightboxInsertions.prototype._getLightboxElements = function() {
  var allLightboxElements = _.filter(this.page.elements, function(elm) {
    return elm.model.linksToExternalLightbox() || elm.model.linksToInternalLightbox();
  });

  // Forms have a main.js file that triggers the lightbox upon submit, so they
  // don't need a script insertion
  var lightboxElementsThatNeedInsertion = _.filter(allLightboxElements, function(elm) {
    return _.contains(['lp-pom-button', 'lp-pom-image'], elm.type);
  });

  return {
    all: allLightboxElements,
    needInsertion: lightboxElementsThatNeedInsertion
  };
};

LightboxInsertions.prototype._getElementScripts = function() {
  // Generates individual calls to lp.lightbox.registerLightbox for each button
  // or image element with lightbox attached
  var self = this;

  return _.map(this.elms.needInsertion, function(elm) {
    var lightboxSize = {
      desktop : elm.model.safeGet('lightboxSize', self.desktopBreakpoint),
      mobile  : elm.model.safeGet('lightboxSize', self.mobileBreakpoint)
    };
    var selector;

    if (elm.type === 'lp-pom-button') {
      selector = '#' + elm.id;
    } else if (elm.type === 'lp-pom-image') {
      selector = '#' + elm.id + ' a';
    }

    if (lightboxSize.desktop && selector) {
      var templateFn = _.template("  window.lp.lightbox.registerLightbox('<%=selector%>', <%=sizes%>)");
      return templateFn({
         selector   : selector,
         sizes      : JSON.stringify(lightboxSize)
      });
    } else {
      return '';
    }
  }).join('\n');
};

module.exports = LightboxInsertions;



// WEBPACK FOOTER //
// ./src/publish/lightbox-insertions.js